import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../modules/app/mainReducer";
import type { Carga } from "../modules/carga/types";
import type { Entrega } from "../modules/carga/utils/agruparEntregas";
import config from "../utils/config";

export function destinoAposConcluirEntrega(entrega: Entrega | undefined, carga: Carga | undefined, j14_ukey?: string): string {
  if (entrega?.link_app) {
    try {
      return new URL(entrega.link_app).pathname;
    } catch (_) {
      // link inválido: segue para os destinos padrão
    }
  }

  if (config.agrupaCargasPeloAgrupamento && carga?.n01_ukey) {
    return `/agrupamentos/${carga.n01_ukey}`;
  }

  return `/cargas/${j14_ukey}`;
}

export default function useRedirecionaAposConcluirEntrega(entrega: Entrega | undefined, carga: Carga | undefined, j14_ukey?: string) {
  const navigate = useNavigate();
  const gestao_entrega_temporario = useSelector((state: RootState) => state.entrega.gestao_entrega_temporario);
  const [destino] = useState(() => destinoAposConcluirEntrega(entrega, carga, j14_ukey));

  useEffect(() => {
    if (!gestao_entrega_temporario) {
      navigate(destino);
    }
  }, [navigate, gestao_entrega_temporario, destino]);
}
